import { useState, useContext } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import Header from "./Header";
import { GetRoutes } from "./Routes";
import { useAuth } from "react-oidc-context";
import { AthleteMain } from "./Athlete";
import { ProfileForm } from "./ProfileForm";
import Footer from "./Footer";

import { Button, Modal, Spinner } from "flowbite-react";
import { HiX, HiCheck, HiFire } from "react-icons/hi";

import { UIContext } from "./UIContext";

const queryClient = new QueryClient();

const Loading = () => {
	const ctx = useContext(UIContext);
	return (
		<>
			{ctx.loading ? (
				<div className="w-screen h-screen fixed z-50 inset-0 bg-gray-900 opacity-50">
					<div className="relative w-full h-full p-auto top-1/2 left-1/2">
						<Spinner />
					</div>
				</div>
			) : (
				<></>
			)}
		</>
	);
};

const AlertBox = () => {
	const ctx = useContext(UIContext);

	let color = "bg-cyan";
	let icon = <HiX />;

	return (
		<Modal
			show={ctx.alert.open}
			onClose={() => ctx.setAlert(ctx.defaultAlert)}
			popup
		>
			<Modal.Header>{ctx.alert.title}</Modal.Header>
			<Modal.Body>
				<div
					className={`${color}`}
					dangerouslySetInnerHTML={{ __html: ctx.alert.message }}
				/>
			</Modal.Body>
		</Modal>
	);
};

function App() {
	const defaultAlert = {
		open: false,
		title: "",
		type: "",
		message: "",
	};
	const [alert, setAlert] = useState(defaultAlert);

	const [loading, setLoading] = useState(false);

	const ctx = {
		alert: alert,
		setAlert: setAlert,
		defaultAlert: defaultAlert,
		loading: loading,
		setLoading: setLoading,
	};

	return (
		<div>
			<UIContext.Provider value={ctx}>
				<QueryClientProvider client={queryClient}>
					<AlertBox />
					<Loading />
					<div className="flex flex-col mx-1 sm:mx-4 min-h-screen">
						<Header />
						<div className="overflow-y-auto flex-grow justify-center px-8 sm:m-auto pt-16 sm:pb-16">
							<Main />
						</div>
						<Footer />
					</div>
				</QueryClientProvider>
			</UIContext.Provider>
		</div>
	);
}

function Main() {
	const auth = useAuth();

	if (auth.isAuthenticated) {
		if (auth.user.profile.realm_access.roles.includes("Sponsors")) {
			return <GetRoutes />;
		}
		if (auth.user.profile.realm_access.roles.includes("Athletes")) {
			return <AthleteMain />;
		}
		return <ProfileForm />;
	}

	return <GetRoutes />;
}
export default App;
